import * as v from 'valibot';
import { integerInRange } from '../util/valibot';
const panelDataSchema = v.object({
    title: v.string()
});
export const panelSchema = v.intersect([
    v.object({
        id: integerInRange(0, 0xffffffff)
    }),
    panelDataSchema
]);
